export const SECTION_IDS = [
  'home',
  'bhalil',
  'rooms',
  'services',
  'gallery',
  'nearby',
  'guides',
  'faq',
  'reviews',
  'findus',
  'contact',
] as const;

export type SectionId = (typeof SECTION_IDS)[number];
